// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-g-1 {
  width: 7.6923076923%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-2 {
  width: 15.3846153846%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-3 {
  width: 23.0769230769%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-4 {
  width: 30.7692307692%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-5 {
  width: 38.4615384615%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-6 {
  width: 46.1538461538%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-7 {
  width: 53.8461538462%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-8 {
  width: 61.5384615385%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-9 {
  width: 69.2307692308%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-10 {
  width: 76.9230769231%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-11 {
  width: 84.6153846154%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-12 {
  width: 92.3076923077%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

.ui-g-13 {
  width: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0.5em;
}

/* Custom CSS for PrimeNG Table with Bootstrap 5 */
.table-primary {
  background-color: #e9f5ff;
  color: #000;
  font-weight: 100;
}

.table-primary th a {
  color: #000;
  text-decoration: none;
}

.table-primary th a:hover {
  color: #0056b3;
}

.text-danger {
  color: #dc3545 !important;
}

.bg-warning {
  background-color: #fff3cd !important;
}

.form-check-input {
  margin: 0 !important;
}

.text-end {
  text-align: end !important;
}

.my-0 {
  margin: 0 !important;
}

.d-flex {
  display: flex !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}`, "",{"version":3,"sources":["webpack://./src/components/activitygrid/activitygrid.component.scss"],"names":[],"mappings":"AAME;EACE,oBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AALJ;;AACE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAEJ;;AANE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AASJ;;AAbE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAgBJ;;AApBE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAuBJ;;AA3BE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AA8BJ;;AAlCE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAqCJ;;AAzCE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AA4CJ;;AAhDE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAmDJ;;AAvDE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AA0DJ;;AA9DE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAiEJ;;AArEE;EACE,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAwEJ;;AA5EE;EACE,WAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AA+EJ;;AA3EA,kDAAA;AAIA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AA2EF;;AAxEA;EACE,WAAA;EACA,qBAAA;AA2EF;;AAxEA;EACE,cAAA;AA2EF;;AAxEA;EACE,yBAAA;AA2EF;;AAxEA;EACE,oCAAA;AA2EF;;AAxEA;EACE,oBAAA;AA2EF;;AA5DA;EACE,0BAAA;AA+DF;;AA5DA;EACE,oBAAA;AA+DF;;AA5DA;EACE,wBAAA;AA+DF;;AA5DA;EACE,oCAAA;AA+DF;;AA5DA;EACE,gCAAA;AA+DF;;AA5DA;EACE,8BAAA;AA+DF","sourcesContent":["@use \"sass:math\";\r\n\r\n$delta-report-columns: 13;\r\n$delta-report-column-width: calc(1 / $delta-report-columns);\r\n\r\n@for $i from 1 through $delta-report-columns {\r\n  .ui-g-#{$i} {\r\n    width: math.percentage($delta-report-column-width * $i);\r\n    float: left;\r\n    box-sizing: border-box;\r\n    padding: 0.5em;\r\n  }\r\n}\r\n\r\n/* Custom CSS for PrimeNG Table with Bootstrap 5 */\r\n\r\n\r\n\r\n.table-primary {\r\n  background-color: #e9f5ff;\r\n  color: #000;\r\n  font-weight: 100;\r\n}\r\n\r\n.table-primary th a {\r\n  color: #000;\r\n  text-decoration: none;\r\n}\r\n\r\n.table-primary th a:hover {\r\n  color: #0056b3;\r\n}\r\n\r\n.text-danger {\r\n  color: #dc3545 !important;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: #fff3cd !important;\r\n}\r\n\r\n.form-check-input {\r\n  margin: 0 !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.text-end {\r\n  text-align: end !important;\r\n}\r\n\r\n.my-0 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.d-flex {\r\n  display: flex !important;\r\n}\r\n\r\n.justify-content-end {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.mb-2 {\r\n  margin-bottom: 0.5rem !important;\r\n}\r\n\r\n.mb-3 {\r\n  margin-bottom: 1rem !important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
